import * as React from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import PersonAdd from "@mui/icons-material/PersonAdd";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { FaXTwitter } from "react-icons/fa6";
import {
  WhatsappShareButton,
  WhatsappIcon,
  FacebookMessengerShareButton,
  FacebookMessengerIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import styled from "@emotion/styled";
import Grid from "@mui/material/Grid";
import { useRouter } from "next/router";
import { usePropertyDetail } from "store/property-detail";
import useDataLayerEvent from "custom-hooks/data-layer-event.hook";
import useGetPersistParams from "custom-hooks/useGetPersintParamas.hook";
export default function SharedNetWork(props: any) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const { property } = usePropertyDetail();
  const referer = useGetPersistParams({ onlyId: true });
  const router = useRouter();
  const { event } = useDataLayerEvent();

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };


  const values = {
    title: "",
    shareUrl: typeof window != "undefined" ? window.location.href : "",
  };

  const handleShare = (platform: any) => {
    const body = {
      codigo_de_propiedad: property?.id,
      ubicacion_propiedad: `${property.address} ${property.sector} ${property.city}`,
      codigo_de_referido: referer,
      plataforma: platform,
    };

    event({
      event_name: "share_remax_network",
      body,
    });

    // setAnchorEl(null);
    if (platform == "Email") {
      window.location.href = `mailto:?subject=Hola le comparto esta propiedad &body=${values.shareUrl}`;
    }
  };

  return (
    <React.Fragment>
      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        {React.cloneElement(props.children, {
          onClick: handleClick,
          id: "share_property",

        })}
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={paperProps}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <CustomMenu>
          <WhatsappShareButton
            onClick={() => handleShare("WhatsApp")}
            url={values.shareUrl}
            title={values.title}
            separator=" "
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>

          {/* <FacebookMessengerShareButton
            url={values.shareUrl}
            appId="521270401588372"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton> */}
          <TwitterShareButton
            url={values.shareUrl}
            title={values.title}
            onClick={() => handleShare("Twitter")}
          >
            <FaXTwitter size={32} color="#2e2e2e" />
          </TwitterShareButton>

          <TelegramShareButton
            url={values.shareUrl}
            title={values.title}
            onClick={() => handleShare("Telegram")}
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>

          <LinkedinShareButton
            url={values.shareUrl}
            onClick={() => handleShare("Linkedin")}
          >
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>

          <EmailShareButton
            onClick={() => handleShare("Email")}
            url={values.shareUrl}
            subject={values.title}
            body="body"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </CustomMenu>
      </Menu>
    </React.Fragment>
  );
}

const paperProps = {
  elevation: 0,
  sx: {
    overflow: "visible",
    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
    mt: 1.5,
    "& .MuiAvatar-root": {
      width: 32,
      height: 32,
      ml: -0.5,
      mr: 1,
    },
    "&:before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      right: 14,
      width: 10,
      height: 10,
      bgcolor: "background.paper",
      transform: "translateY(-50%) rotate(45deg)",
      zIndex: 0,
    },
  },
};

const CustomMenu = styled(MenuItem)`
  display: grid;
  grid-template-columns: repeat(3, 40px);
  grid-template-rows: repeat(2, 40px);
`;